"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const test_1 = require("../test");
class TwingNodeExpressionTestSameAs extends test_1.TwingNodeExpressionTest {
    compile(compiler) {
        compiler
            .raw('(')
            .subcompile(this.getNode('node'))
            .raw(' === ')
            .subcompile(this.getNode('arguments').getNode(0))
            .raw(')');
    }
}
exports.TwingNodeExpressionTestSameAs = TwingNodeExpressionTestSameAs;
